//C:\ViYash\XPRSuvey\XPRSuvey-App\src\Components\HR\Services\CompanyAnalytics.js
import api from "../../axios";

export const getAssessmentFactor = (assessmentUID) =>{
    return api.get("/api/XPRSCompanyAnalysis/assessment-factors", {params: {assessmentUID,},
    });
};

export const getScoringConfig = (surveyUID) => {
    return api.get("/api/XPRSCompanyAnalysis/scoring-config", { params: { surveyUID, }, });
};

export const getQuestionAnalytics = (questionUID) => {
    return api.get("/api/XPRSCompanyAnalysis/question-analysis", { params: { questionUID, }, });
};
